import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFlags } from "api/flags";

export const downloadFlags = createAsyncThunk("flag/download", async () => {
  return await getFlags();
});
